import { SecurityService } from '../security/security.service';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../security/security.service";
var StudentAuthorizationService = /** @class */ (function () {
    function StudentAuthorizationService(http, securityService) {
        this.http = http;
        this.securityService = securityService;
    }
    StudentAuthorizationService.prototype.postAuthorize = function (postdata) {
        var _this = this;
        var url = '/api/tsorder/authorize';
        return this.http.post(url, postdata).pipe(catchError(function (error) { return _this.securityService.catchResponse(error); }));
    };
    StudentAuthorizationService.ngInjectableDef = i0.defineInjectable({ factory: function StudentAuthorizationService_Factory() { return new StudentAuthorizationService(i0.inject(i1.HttpClient), i0.inject(i2.SecurityService)); }, token: StudentAuthorizationService, providedIn: "root" });
    return StudentAuthorizationService;
}());
export { StudentAuthorizationService };
